import { styled } from './druid/./druid/Utilities';
import { FabricBase } from '/druid/Fabric.base';
import { getStyles } from '/druid/Fabric.styles';
import { IFabricProps, IFabricStyleProps, IFabricStyles } from '/druid/Fabric.types';

export const Fabric = styled<IFabricProps, IFabricStyleProps, IFabricStyles, FabricBase>(
  FabricBase,
  getStyles,
  undefined,
  {
    scope: 'Fabric',
  },
);
